import { render, staticRenderFns } from "./confirm_reset_password.vue?vue&type=template&id=3eb4bdf7"
import script from "./confirm_reset_password.vue?vue&type=script&lang=js"
export * from "./confirm_reset_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports